import Cookies from "js-cookie";

// ======== Cookie Hanlding ========
// Functions are set, get and remove
// Set : set your cookie by passing name and data as parameters to function. You can pass any type of datas to cookie : setCookie('test', 'test cookie set!')
// Get : get your cookie by passing name as parameters to function : getCookie('test')
// Remove : remove your cookie by passing name as parameters to function : removeCookie('test')

export function setCookie(name, data, time) {
    const secureFlag = window.location.protocol === "https:" ? true : false; // Secure cookies only on HTTPS

    if (typeof data === "object") {
        Cookies.set(name, JSON.stringify(data), {
            expires: time || 14, // Default to 14 days if not provided
            secure: secureFlag,
            sameSite: "Strict",
            path: "/"
        })
    } else {
        Cookies.set(name, data, {
            expires: time || 14,
            secure: secureFlag,
            sameSite: "Strict",
            path: "/"
        })
    }
}

export function getCookie(name) {
    if(Cookies.get(name)) {
        if(Cookies.get(name).indexOf('{') == 0 || Cookies.get(name).indexOf('[') == 0) {
            return JSON.parse(Cookies.get(name))
        } else {
            return Cookies.get(name)
        }
    } else {
        // console.log('Cookie not found! : ' + name)
        return undefined
    }
}

export function removeCookie(name) {
    Cookies.remove(name, { path: "" }) // Removes from other paths just in case
}